import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/api/api.service';
import { SOPRA_ENDPOINTS } from 'src/app/core/api/endpoints/sopra.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class SopraConfigurationsService {
  private api = inject(ApiService);

  getClassifications(params?: any) {
    return this.api.get(SOPRA_ENDPOINTS.V2.CLASSIFICATIONS, { params });
  }

  getClassificationDetails(classificationId: number) {
    return this.api.get(SOPRA_ENDPOINTS.V2.CLASSIFICATION(classificationId));
  }

  updateClassification(classificationId: number, data: any, buttonId?: string) {
    let options: any = {};

    if (buttonId) {
      options.context = new HttpContext().set(BUTTON_LOADING_ID, buttonId);
    }
    return this.api.put(SOPRA_ENDPOINTS.V2.CLASSIFICATION(classificationId), data, options);
  }

  createClassification(data: any, buttonId?: string) {
    let options: any = {};
    if (buttonId) {
      options.context = new HttpContext().set(BUTTON_LOADING_ID, buttonId);
    }
    return this.api.post(SOPRA_ENDPOINTS.V2.CLASSIFICATIONS, data, options);
  }
}
